import { Nav, NavItem } from 'reactstrap';
import styled, { css } from 'styled-components';

export const StyledNavItem = styled(NavItem)`
  a {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray400};

    &:hover {
      color: ${({ theme }) => theme.colors.gray400};
    }
  }

  ${({ active, theme }) =>
    active &&
    css`
      a {
        color: ${theme.colors.primary};
        background-color: ${theme.colors.white};

        &:hover {
          color: ${theme.colors.primary};
        }
      }

      border-bottom: 3px solid ${theme.colors.primary}!important;
    `}

  .nav-link.disabled {
    color: #e5e5e5;
  }
  &.is-invalid {
    .nav-link {
      color: ${({ theme }) => theme.colors.danger};
    }
    border-bottom-color: ${({ theme }) => theme.colors.danger} !important;
  }
`;

export const StyledNav = styled(Nav)`
  display: flex;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
